import React, { useCallback, useRef, useState } from 'react';
import cn from 'classnames';
import { noop } from 'lodash';

import COLOR_NAME from 'constants/colors.const';
import useOnClickOutside from 'hooks/useOnClickOutsideRef.hook';
import useTip from 'hooks/useTip.hook';
import call from 'utils/functions/call.util';
import asObject from 'utils/objects/asObject.util';
import isFn from 'utils/predicates/function/isFn.util';

import ColorMenu from './ColorMenu.component';

import CN from './ColorPicker.module.scss';

const ColorPicker = ({ name, active, items: itemsFromProps, onChange: onChangeFromProps }) => {
  const items = asObject(itemsFromProps);
  const onChange = isFn(onChangeFromProps) ? onChangeFromProps : noop;

  const { val: isOpen, tip: toggleOpen, nay: close } = useTip(false);
  const [activeColor, setActiveColor] = useState(active);

  const pickerRef = useRef(null);

  useOnClickOutside(pickerRef, close);

  const pattern = cn({
    [CN.pattern]: true,
    [CN.yellow]: activeColor === COLOR_NAME.yellow,
    [CN.orange]: activeColor === COLOR_NAME.orange,
    [CN.red]: activeColor === COLOR_NAME.red,
    [CN.green]: activeColor === COLOR_NAME.green,
    [CN.greenLight]: activeColor === COLOR_NAME.greenLight,
    [CN.purple]: activeColor === COLOR_NAME.purpleLight || activeColor === COLOR_NAME.purple || activeColor === COLOR_NAME.pinkLight,
    [CN.purpleDark]: activeColor === COLOR_NAME.purpleDark,
    [CN.blue]: activeColor === COLOR_NAME.blueLight || activeColor === COLOR_NAME.blueMatte,
    [CN.black]: activeColor === COLOR_NAME.black,
  });

  const handleClick = useCallback(
    (color) => {
      setActiveColor(color);

      if (isFn(onChange)) {
        call('ColorPicker.onChange', onChange, { name, value: color });
      }
    },
    [name, onChange],
  );

  return (
    <div data-bem="ColorPicker" className={CN.component} ref={pickerRef}>
      <div
        className={CN.colorButton}
        style={{
          background: activeColor,
        }}
      >
        <div className={pattern} role="button" tabIndex="0" onClick={toggleOpen} />
      </div>
      {isOpen && <ColorMenu items={items} activeColor={activeColor} onClick={handleClick} />}
    </div>
  );
};

export default ColorPicker;
